/* Accordéons animés.

   Un <details> natif bascule instantanément : le navigateur affiche ou masque
   son contenu sans étape intermédiaire. On garde la sémantique (et donc la
   navigation clavier, la recherche dans la page, l'absence de JavaScript en
   repli) mais on prend la main sur l'ouverture pour animer la hauteur.

   L'animation ne doit jamais empêcher l'ouverture : chaque transition est
   doublée d'une échéance qui applique l'état final, même si le navigateur
   met les animations en pause (onglet en arrière-plan, par exemple).
*/

/* Plusieurs sections peuvent demander ce fichier sur une même page
   (fiche produit, FAQ, points forts). On l'enferme dans une fonction pour
   que le second chargement ne heurte pas les constantes du premier. */
(function siritoAccordion() {
  const DURATION_OPEN = 300;
  const DURATION_CLOSE = 260;
  const EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  class SiritoAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.summary = this.details.querySelector('summary');
      this.content = this.summary ? this.summary.nextElementSibling : null;
      if (!this.summary || !this.content) return;

      this.animation = null;
      this.timer = null;

      this.summary.addEventListener('click', (event) => this.onClick(event));
    }

    get canAnimate() {
      return (
        typeof this.details.animate === 'function' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    onClick(event) {
      // Sans animation possible ou souhaitée, le comportement natif suffit.
      if (!this.canAnimate) return;

      event.preventDefault();
      if (this.details.open) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      // On ouvre d'abord : le contenu doit être mesurable avant d'animer.
      this.details.open = true;
      this.details.style.overflow = 'hidden';

      const start = this.summary.offsetHeight;
      const end = this.summary.offsetHeight + this.content.offsetHeight;
      this.run(start, end, DURATION_OPEN, true);
    }

    collapse() {
      this.details.style.overflow = 'hidden';

      const start = this.details.offsetHeight;
      const end = this.summary.offsetHeight;
      this.run(start, end, DURATION_CLOSE, false);
    }

    run(start, end, duration, open) {
      this.cancel();

      this.animation = this.details.animate(
        { height: [`${start}px`, `${end}px`] },
        { duration, easing: EASING }
      );
      this.animation.onfinish = () => this.settle(open);

      // Filet : si l'animation ne rend jamais la main, l'accordéon se fige.
      // On applique l'état final au plus tard à l'échéance prévue.
      this.timer = window.setTimeout(() => this.settle(open), duration + 120);
    }

    cancel() {
      if (this.animation) {
        this.animation.onfinish = null;
        this.animation.cancel();
        this.animation = null;
      }
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    settle(open) {
      this.cancel();
      this.details.open = open;
      // On rend la main à la mise en page : plus de hauteur ni de rognage forcés.
      this.details.style.height = '';
      this.details.style.overflow = '';
    }
  }

  /* Deux sections peuvent demander ce script sur la même page : on ne
     redéfinit pas un élément déjà enregistré. */
  if (!customElements.get('sirito-accordion')) {
    customElements.define('sirito-accordion', SiritoAccordion);
  }

})();
